import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { RestServices } from '../../../../services/rest.services'
import { AuthService } from '../../../../services/auth.services'
import { imageUrl } from '../../../../../helper/common'
import { MatrixServices } from '../../../../services/image/matrix.services'

@Component({
    selector: 'app-list-communication',
    templateUrl: './list-communication.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/root-ui-view.component.css',
        './list-communication.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class ListCommunicationComponent implements OnInit {
    en = {}
    showEN = true
    arrList
    baseUrl = imageUrl

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, public matrixServices: MatrixServices) {
        this.listCommunication()
    }

    ngOnInit() {
    }

    // list staff
    listCommunication() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
                room: {
                    searches: {
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    this.arrList = success['response']['room']['searches']['{}']
                },
            )
        })
    }

    routerLink() {
        this.router.navigateByUrl('app/main/communication/new')
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    selectRoom(id) {
        this.router.navigateByUrl('/app/main/communication/room/' + id + '/home')
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/communication/list-communication/list-communication.component.ts